import { rolesFeature, rolesAdapter } from './role.reducer';

export const {
  selectRolesState,
  selectTotal: selectRolesTotal,
  selectPage: selectRolesPage,
  selectLimit: selectRolesLimit,
  selectLoading: selectRolesLoading,
  selectError: selectRolesError,
} = rolesFeature;

const entitySelectors = rolesAdapter.getSelectors(selectRolesState);
export const selectAllRoles = entitySelectors.selectAll;
export const selectRoleEntities = entitySelectors.selectEntities;
